import React from "react";
import { useTranslation } from "react-i18next";
import {
	IEventPlayer,
	IPlayerStatGroup,
} from "@data-types/sport-stats/SportStatsTypes";
import classnames from "classnames";

export function PlayerStatsGroupBody(props: {
	statsGroup: IPlayerStatGroup;
	isExpanded: boolean;
	player: IEventPlayer;
}) {
	const { isExpanded, statsGroup, player } = props;

	const { t } = useTranslation();

	if (!isExpanded) {
		return null;
	}

	return (
		<div
			className={classnames("statistics__body", {
				"is-collapsed": !isExpanded,
			})}
		>
			{statsGroup.key !== "goalkeeper" && (
				<div key={player.position} className="statistics__row">
					<div className="statistics__col u-type--left">
						{t(
							"EVENT.STATISTICS.PLAYER_STATS.PLAYER_STAT_TITLES.POSITION"
						)}
					</div>
					<div className="statistics__col u-type--wgt--medium">
						{player.position}
					</div>
				</div>
			)}

			{statsGroup.data.map((stat, index) => (
				<div key={index} className="statistics__row">
					<div className="statistics__col u-type--left">
						{t(stat.title)}
					</div>
					<div className="statistics__col u-type--wgt--medium">
						{player.statistics[statsGroup.key]?.[stat.key] || "0"}
					</div>
				</div>
			))}
		</div>
	);
}
